import { Box, Divider } from '@mui/material'
import * as React from 'react'

import PdfFooter from './PdfFooter'

export const PdfContent = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box
            sx={{
                fontSize: '12px',
                width: '100%',
                padding: '20px',
                '.steps_explanation-text': {
                    whiteSpace: 'break-spaces',
                },
                '.steps_explanation-wrapper': {
                    lineHeight: '30px',
                },
                '.steps_explanation-chip': {
                    display: 'inline',
                },
                zoom: 0.8,
            }}
        >
            {children}
            <Box sx={{ mt: 9 }}>
                <Divider />
                <PdfFooter />
            </Box>
        </Box>
    )
}

export default PdfContent
